<template>
  <!--
    readExcelData: function(rowNumber, cells, dataTypes, func) excel data 읽을 때 사용
      - rowNumber: 현재 row number
      - cells: 현재 row 의 cell data
      - dataTypes: tableDataType, 사용자가 임의로 정하는 타입
      - func: ExcelUploadNormalTemplate.vue 의 method
        - func.save(cells, error) excel data 저장
        - func.findFieldByFieldName(fieldName) fieldName 으로 field 찾기, useFieldCell 이 true 일때만 사용
        - func.toTel(string) string 을 전화번호 타입으로 변경

    setSaveFormData
  -->
  <normal-excel-upload
    ref="normalExcelUpload"
    :board="board"
    title="운전자 자격관리 엑셀 업로드"
    :useFieldCell="true"
    :downloadLink="downloadLink"
    tableTitle="등록 대상 운전자 자격 정보"
    :tableHeader="tableHeader"
    :tableDataType="tableDataType"
    :readExcelData="readExcelData"
    :setSaveFormData="setSaveFormData"
    @onExcelDataChange="onExcelDataChange"
    @onDuplicateRemove="onDuplicateRemove"
  >
    <!--
      index: column index
      data: column data
      dataType: 사용자가 임의로 정하는 타입
      funcSetEditExcelData: function(index, data, errorMSG) edit excel data 수정시 사용
        - errorMGS = "": 정상
        - errorMGS = "error message": 에러 메시지
        - errorMGS = undefined: 에러 메시지 변경안함
    -->
    <template v-slot:edit="{ index, data, dataType, funcSetEditExcelData }">
      <fragment v-if="dataType === 'no'">{{ data }}</fragment>
      <fragment v-else-if="dataType === 'field'">
        <field-selector class="w-full text-left" v-model="data.id" @select="(field) => onSelectField(field, { index, data, funcSetEditExcelData })" />
      </fragment>
      <fragment v-else-if="dataType === 'selector'">
        <custom-option-selector class="w-full" :options="result_options" :value="data" @input="(data) => funcSetEditExcelData(index, data, '')" />
      </fragment>
      <fragment v-else-if="dataType === 'file'">
        <FileUploader class="w-full" :value="data" @input="(data) => funcSetEditExcelData(index, data, '')" />
      </fragment>
      <fragment v-else>
        <ml-input class="w-full" :value="data" @input="(value) => funcSetEditExcelData(index, value, '')" />
      </fragment>
    </template>
    <template v-slot:column="{ index, data, dataType }">
      <p v-if="index === 1">{{ data.field_name || "-" }}</p>
      <p v-else-if="dataType === 'file' && data" @click="() => onClickFileDownload(data)" style="color: rgb(126, 114, 242)" class="underline cursor-pointer">{{ data.fileName }}</p>
      <p v-else>{{ data || "-" }}</p>
    </template>
  </normal-excel-upload>
</template>

<script>
import NormalExcelUpload from "@/views/excel-upload/NormalExcelUpload.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";
import config from "/public/config";
import { downloadFile } from "@/util/DataUtil";
import { checkExcelDataDuplicates } from "@/util/ExcelCheckUtil";

export default {
  components: {
    CustomOptionSelector,
    FileUploader,
    FieldSelector,
    NormalExcelUpload,
  },
  props: {
    board: Object,
  },
  data() {
    return {
      result_options: ["크레인", "크레인(리모콘)", "지게차"],

      downloadLink: `${config.BASE_API_URL}/storage/app/media/%EB%8F%99%EA%B5%AD%EC%A0%9C%EA%B0%95_%EC%9A%B4%EC%A0%84%EC%9E%90_%EC%9E%90%EA%B2%A9%EA%B4%80%EB%A6%AC_%EC%97%91%EC%85%80_%EC%97%85%EB%A1%9C%EB%93%9C.xlsx`,
      tableDataType: ["no", "field", "string", "string", "selector", "string", "file"],
      tableHeader: ["No.", "사업장명", "팀명", "이름", "구분", "자격번호", "자격증 첨부"],
      // 실제 form.subInfo 에 저장되는 데이터이므로 no 를 사용하지 않습니다.
      tableDataValue: ["팀명", "이름", "구분", "자격번호", "자격증첨부"],
      existDataList: ["자격번호"],
      isProcessing: false,
      lastProcessedData: null,
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
  },
  methods: {
    onClickFileDownload(data) {
      downloadFile(data.fileName, data.path);
    },
    onSelectField(field, edit) {
      const data = {
        id: field.id,
        field_name: field.field_name,
      };
      const errorMSG = field.id ? "" : "입력된 데이터가 검색되지 않습니다.";
      edit.funcSetEditExcelData(edit.index, data, errorMSG);
    },
    readExcelData(rowNumber, cells, dataTypes, func) {
      if (rowNumber > 2) {
        const field = func.findFieldByFieldName(cells[1]);
        const error = [];

        cells.forEach((cell, index) => {
          if (dataTypes[index] === "no") {
            cells[index] = func.rowIndex;
          } else if (dataTypes[index] === "field") {
            if (field) {
              cells[index] = {
                id: field.id,
                field_name: field.field_name,
              };
            } else {
              cells[index] = {
                id: 0,
                field_name: cells[index],
              };
              error[index] = "입력된 데이터가 검색되지 않습니다.";
            }
          } else if (dataTypes[index] === "selector") {
            if (!this.result_options.includes(cell)) {
              cells[index] = "";
              error[index] = "올바른 구분 값을 선택해주세요";
            }
          }
        });
        func.save(cells, error);
      }
    },

    setSaveFormData(datas, stdInfo) {
      const form = {
        stdInfo: {
          ...stdInfo,
          field_id: datas[1].id,
          field_name: datas[1].field_name,
        },
        subInfo: {},
      };
      this.tableDataValue.forEach((key, index) => {
        form.subInfo[key] = datas[index + 2];
      });

      const date = new Date();
      const header = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        date: date.format("yyyy-MM-dd"),
        full: date.format("yyyy-MM-dd"),
      };

      return {
        header,
        body: form,
      };
    },

    onExcelDataChange(datas) {
      // 이미 처리 중인 경우 중첩 호출 방지
      if (this.isProcessing) {
        return;
      }

      // 디바운스 처리 - 연속된 데이터 변경 시 마지막 변경만 처리
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.processExcelDataChanges(datas);
      }, 300); // 300ms 디바운스
    },

    processExcelDataChanges(datas) {
      this.isProcessing = true;

      try {
        // 유틸리티 함수 호출
        checkExcelDataDuplicates({
          excelData: datas,
          existDataList: this.existDataList,
          tableDataValue: this.tableDataValue,
          projectId: this.projectId,
          boardId: this.boardId,
          dispatch: this.$store.dispatch,
          lastProcessedData: this.lastProcessedData,
        }).then((result) => {
          // 마지막으로 처리한 데이터 업데이트
          this.lastProcessedData = JSON.parse(JSON.stringify(datas));

          // 중복 에러가 발생한 경우 UI 업데이트
          if (result.hasError) {
            this.$nextTick(() => {
              // 에러 메시지가 포함된 데이터로 NormalExcelUpload 컴포넌트 업데이트
              if (this.$refs.normalExcelUpload && typeof this.$refs.normalExcelUpload.updateExcelData === "function") {
                this.$refs.normalExcelUpload.updateExcelData(datas);
              }
            });

            // 에러 메시지가 표시되도록 $forceUpdate 실행
            if (this.$refs.normalExcelUpload) {
              this.$refs.normalExcelUpload.$forceUpdate();
            }
          }
        });
      } catch (error) {
        console.error("중복 데이터 검사 중 오류 발생:", error);
      } finally {
        // 처리 완료 후 플래그 해제
        this.isProcessing = false;
      }
    },

    // 중복 데이터가 삭제되었을 때 호출되는 이벤트 핸들러
    onDuplicateRemove(datas) {
      // 데이터가 변경되었으므로 lastProcessedData 업데이트
      this.lastProcessedData = JSON.parse(JSON.stringify(datas));

      // 중복 검사를 다시 실행하지 않도록 플래그 설정
      this.isProcessing = true;

      // 데이터가 삭제된 후 UI 업데이트
      this.$nextTick(() => {
        if (this.$refs.normalExcelUpload) {
          this.$refs.normalExcelUpload.$forceUpdate();
        }

        // 처리 완료 후 플래그 해제 (약간의 딜레이를 두어 onExcelDataChange와 충돌 방지)
        setTimeout(() => {
          this.isProcessing = false;
        }, 100);
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
